import { Box, Typography } from "@mui/material";
import { NavLink, useMatch } from "react-router-dom";
import {
  MahaloParticipantIcon,
  QuestionnaireActiveIcon,
  QuestionnaireInactiveIcon,
  EConsentInactiveIcon,
  EConsentActiveIcon,
  CircleSmallLogo,
  // AppointmentsActiveIcon,
  // AppointmentsInactiveIcon,
  //   HomeActiveIcon,
  //   HomeInactiveIcon,
} from "../Common/assets/Sidebar";
import { useAppSelector } from "../../Redux/hooks";
import VersionWrapper from "../Common/UI/VersionWrapper";

import SidebarToggle from "./SidebarToggle";

type Props = {
  isMobile: boolean;
};

const ParticipantSidebar = ({ isMobile }: Props) => {
  const { collapsed } = useAppSelector((state) => state.app);
  const showLabel = !collapsed || isMobile;

  const matchFunctions: {
    [key: string]: boolean;
  } = {
    home: !!useMatch("/participant/home/*"),
    questionnaires: !!useMatch("/participant/questionnaires/*"),
    eConsent: !!useMatch("/participant/e-consent/*"),
    // appointments: !!useMatch("/participant/appointments/*"),
  };

  return (
    <Box
      className={`sidebar ${collapsed && !isMobile ? "collapsed" : ""}`}
      sx={{
        "& .sider-menu": {
          color: "text.secondary",
          "& .MuiTypography-root": {
            fontWeight: 400,
            fontSize: "16px",
          },
        },
        "& .active.sider-menu": {
          backgroundColor: "secondary.main",
          "& .MuiTypography-root": {
            color: "primary.main",
            fontWeight: 500,
          },
          color: "primary.main",
        },
        "& .user-management-menu": {
          color: "text.secondary",
        },
        "& .active.user-management-menu": {
          color: (theme) => theme.palette.primary.main,
        },
      }}
    >
      <SidebarToggle type="study" />
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: 2,
            marginBlock: "10px",
          }}
        >
          {collapsed && !isMobile ? (
            <CircleSmallLogo />
          ) : (
            <MahaloParticipantIcon />
          )}
        </Box>
        {/* <NavLink
          to={`/participant/home`}
          title="Home"
          className={({ isActive }) =>
            isActive ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.home ? <HomeActiveIcon /> : <HomeInactiveIcon />}
          {!collapsed && <Typography variant="subtitle1">Home</Typography>}
        </NavLink> */}
        <NavLink
          title="Questionnaires"
          to={`/participant/questionnaires`}
          className={
            matchFunctions.questionnaires ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.questionnaires ? (
            <QuestionnaireActiveIcon />
          ) : (
            <QuestionnaireInactiveIcon />
          )}
          {showLabel && <Typography>Questionnaires</Typography>}
        </NavLink>
        <NavLink
          title="eConsent"
          to={`/participant/e-consent`}
          className={
            matchFunctions.eConsent ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.eConsent ? (
            <EConsentActiveIcon />
          ) : (
            <EConsentInactiveIcon />
          )}

          {showLabel && <Typography>eConsent</Typography>}
        </NavLink>
        {/* <NavLink
          title="Appointments"
          to={`/participant/appointments`}
          className={
            matchFunctions.appointments ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.appointments ? (
            <AppointmentsActiveIcon />
          ) : (
            <AppointmentsInactiveIcon />
          )}

          {showLabel && <Typography>Appointments</Typography>}
        </NavLink> */}
      </Box>
      <VersionWrapper participant={true} />
    </Box>
  );
};

export default ParticipantSidebar;
